module.exports = __webpack_public_path__ + "img/sacredgrove_tech_Normal_ua.d129cc3e.webp";